import * as providers from './provider'

export default (setList, setError, initialState) => {
  const setField = (value, field) =>
    setList(prev => ({ ...prev, [field]: value }))

  const setListLoading = value =>
    setList(prev => ({ ...prev, loadingList: value }))

  const fetchList = async query => {
    setField(true, 'loadingList')

    const listData = await providers.getEstatesList(query)

    if (listData && listData.error) {
      return setError(listData.code)
    }

    const { list = [], pagination = {} } = listData || {}

    return setList(prev => ({
      ...prev,
      estatesList: list,
      pagination,
      loadingList: false,
    }))
  }

  const clearList = () => setList(() => ({ ...initialState }))

  const fetchBanner = async () => {
    const [bannerImageError, bannerImageResult] = await providers.bannerImage()

    if (bannerImageError) {
      // eslint-disable-next-line no-console
      console.error('Erro ao buscar imagem do banner', bannerImageError)
      return
    }

    setList(prev => ({
      ...prev,
      bannerImageDesk: bannerImageResult.data[0].url_desktop,
      bannerImageMobile: bannerImageResult.data[0].url_mobile,
      banneLink: bannerImageResult.data[0].link,
    }))
  }

  return {
    setField,
    fetchList,
    setListLoading,
    clearList,
    fetchBanner,
  }
}
